module.exports = __webpack_public_path__ + "img/13 Animation 2-squashed.61dd5271.jpg";